"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageHelper = exports.SuccessMessages = exports.ErrorMessages = exports.SuccessMessage = exports.WarningMessage = exports.ErrorMessage = exports.Message = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var icon_error_svg_1 = __importDefault(require("../../assets/images/icon-error.svg"));
var icon_warning_svg_1 = __importDefault(require("../../assets/images/icon-warning.svg"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
exports.Message = styled_components_1.default.ul.attrs({
    className: 'tws-input-message tws-input-validation-message-wrapper',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t {\n\t\tfont-size: 13px;\n\t\tfont-weight: 500;\n\t\tline-height: 1.2em;\n\t\tmargin: 5px 0;\n\t\tmin-height: 20px;\n\t\tpadding: ", ";\n\t\ttext-align: left;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t}\n"], ["\n\t {\n\t\tfont-size: 13px;\n\t\tfont-weight: 500;\n\t\tline-height: 1.2em;\n\t\tmargin: 5px 0;\n\t\tmin-height: 20px;\n\t\tpadding: ", ";\n\t\ttext-align: left;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t}\n"])), globalVars_module_scss_1.default.spacing0);
exports.Message.displayName = 'Message';
exports.ErrorMessage = (0, styled_components_1.default)(exports.Message)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t {\n\t\tbackground-image: url(", ");\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: 14px 14px;\n\t\tbackground-position: 0px 2px;\n\t\tcolor: #e00000;\n\t\tpadding-left: 20px;\n\t\tpadding-top: 3px;\n\t}\n"], ["\n\t {\n\t\tbackground-image: url(", ");\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: 14px 14px;\n\t\tbackground-position: 0px 2px;\n\t\tcolor: #e00000;\n\t\tpadding-left: 20px;\n\t\tpadding-top: 3px;\n\t}\n"])), icon_error_svg_1.default);
exports.ErrorMessage.displayName = 'ErrorMessage';
exports.WarningMessage = (0, styled_components_1.default)(exports.Message)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t {\n\t\tbackground-image: url(", ");\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: 14px 14px;\n\t\tbackground-position: 0px 2px;\n\t\tcolor: #e00000;\n\t\tpadding-left: 20px;\n\t\tpadding-top: 3px;\n\t}\n"], ["\n\t {\n\t\tbackground-image: url(", ");\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: 14px 14px;\n\t\tbackground-position: 0px 2px;\n\t\tcolor: #e00000;\n\t\tpadding-left: 20px;\n\t\tpadding-top: 3px;\n\t}\n"])), icon_warning_svg_1.default);
exports.WarningMessage.displayName = 'WarningMessage';
exports.SuccessMessage = (0, styled_components_1.default)(exports.Message)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t {\n\t\tcolor: ", ";\n\t}\n"], ["\n\t {\n\t\tcolor: ", ";\n\t}\n"])), globalVars_module_scss_1.default.secondaryGreen);
exports.SuccessMessage.displayName = 'SuccessMessage';
var getMessages = function (message) {
    if (!message || (typeof message === 'string' && !message.trim())) {
        return undefined;
    }
    var messages = typeof message === 'string' ? [message] : message.filter(function (m) { return m && m.length > 0; });
    return messages;
};
var getFormattedErrorMessages = function (message) {
    var messages = getMessages(message);
    var listItems = messages &&
        messages.map(function (m, index) { return (React.createElement("li", { key: 'input-message-' + index, className: 'tws-error-message' },
            index === 0 ? React.createElement("b", null, "Error ") : '',
            "- ",
            m)); });
    return React.createElement(exports.ErrorMessage, null, listItems);
};
var getFormattedWarningMessages = function (message) {
    var messages = getMessages(message);
    var listItems = messages &&
        messages.map(function (m, index) { return (React.createElement("li", { key: 'input-message-' + index, className: 'tws-warning-message' },
            index === 0 ? React.createElement("b", null, "Warning ") : '',
            "- ",
            m)); });
    return React.createElement(exports.WarningMessage, null, listItems);
};
// NOTE: I do not see anything in the style guide for this. It's here to maintain functionality in case anything
// 		 is using it. There are no demos for it either.
var getFormattedSuccessMessages = function (message) {
    var messages = getMessages(message);
    var listItems = messages &&
        messages.map(function (m, index) { return (React.createElement("li", { key: 'input-message-' + index, className: 'tws-success-message' }, m)); });
    return React.createElement(exports.SuccessMessage, null, listItems);
};
var ErrorMessages = function (props) {
    return (React.createElement(exports.ErrorMessage, { id: props.id }, props.messages.map(function (msg, idx) { return (React.createElement("li", { key: 'input-message-' + idx, className: 'tws-error-message' },
        idx === 0 ? React.createElement("b", null, "Error ") : '',
        "- ",
        msg)); })));
};
exports.ErrorMessages = ErrorMessages;
var SuccessMessages = function (props) {
    return (React.createElement(exports.SuccessMessage, { id: props.id }, props.messages.map(function (msg, idx) { return (React.createElement("li", { key: 'input-message-' + idx, className: 'tws-success-message' }, msg)); })));
};
exports.SuccessMessages = SuccessMessages;
exports.MessageHelper = {
    getMessages: getMessages,
    getFormattedErrorMessages: getFormattedErrorMessages,
    getFormattedSuccessMessages: getFormattedSuccessMessages,
    getFormattedWarningMessages: getFormattedWarningMessages,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
